export default __webpack_public_path__ + "static/media/search-image.d0cf8aad.jpg";